import { withStyles, createStyles, makeStyles } from '@material-ui/core/styles';
import { TableRow, TableCell } from '@material-ui/core';
export const StyledTableCell = withStyles((theme) => createStyles({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: 13
    },
    body: {
        fontSize: 12,
    },
}))(TableCell);
export const StyledTableRow = withStyles((theme) => createStyles({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        "&:hover": {
            backgroundColor: theme.palette.action.selected,
            cursor: "pointer"
        }
    },
    tableRow: {}
}))(TableRow);
export const useStyles = makeStyles({
    tabRoot: {
        flexGrow: 1,
    },
});
